export default {
  forward: 'Forward',
  cancel: 'Cancel',
  customNumber: 'Custom number'
};
